var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleInfo = function SvgCircleInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 3.6a8.4 8.4 0 1 1 0 16.8 8.4 8.4 0 0 1 0-16.8m0 18a9.6 9.6 0 1 0 0-19.199 9.6 9.6 0 0 0 0 19.2m-2.4-6v1.2h4.8v-1.2h-1.8v-4.8H9.9V12h1.5v3.6H9.6m3.3-6.3V7.5h-1.8v1.8z"
  })));
};
export default SvgCircleInfo;